import paper from 'paper';

export function initializePaper() {
    return new Promise(function (resolve) {
        if (paper && paper.project) {
            paper.project.clear();
            paper.project.remove();
        }
        paper.setup();
        paper.settings.insertItems = false;
        resolve();
    });
}
